export interface IApplicationConfig {
	language: KnockoutObservable<string>;
	isRightToLeftLanguage: KnockoutObservable<boolean>;
	rtlCss: KnockoutComputed<string>;
	defaultLanguage: string;
}

export var ApplicationConfig: IApplicationConfig = {
	language: ko.observable('en'),
	isRightToLeftLanguage: ko.observable(false),
	rtlCss: ko.pureComputed(() => {
		return ApplicationConfig &&
			ko.isObservable(ApplicationConfig.isRightToLeftLanguage) &&
			ApplicationConfig.isRightToLeftLanguage()
			? 'rtl'
			: 'ltr';
	}),
	defaultLanguage: 'en'
};
